import script from "./ContactInfoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactInfoSection.vue?vue&type=script&setup=true&lang=js"

import "./ContactInfoSection.vue?vue&type=style&index=0&id=06c001ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06c001ab"]])

export default __exports__